import React, { memo } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import "../../styles/ModalShared.css";
import { ChatDisableModal as ModalConstants } from "../../constants/Modal";

const ChatDisableModalComponent = ({
  isOpen,
  toggle,
  title = "",
  bodyContent = "",
  footerContent = null,
  disableClose = false,
  userDetails = {},
}) => {
  const { primary = {} } = userDetails; 
  const getTitle = () => {
    if (primary?.share === false || primary?.is_active === false) {
      return ModalConstants.titles.notShared;
    }

    return ModalConstants.titles.default;
  };

  const getBodyContent = () => {
    // when the user is deleted
    if (primary?.is_active === false) {
      return ModalConstants.bodies.deleted;
    } else if (primary?.share === false) { //  when the user has not shared their profile
      return ModalConstants.bodies.notShared;
    }

    return ModalConstants.bodies.default;
  };

  // Determine if the close icon should be shown
  const showCloseIcon = (primary?.share === false || primary?.is_active === false);

  // Determine if the modal can be closed using the escape key
  const allowEscape = !(primary?.share === false || primary?.is_active === false);

  const canClose = !disableClose && showCloseIcon ? toggle : undefined;

  // Prevent right-click if primary.share is false
  const handleContextMenu = (e) => {
    if (primary?.share === false || primary?.is_active === false) {
      e.preventDefault();
    }
  };

  return (
    <Modal zIndex={9999999}
      isOpen={isOpen}
      toggle={canClose}
      centered
      className="custom-modal"
      backdrop={allowEscape ? true : "static"} // Prevent escape key close if not allowed
      onContextMenu={handleContextMenu} // Attach the context menu handler
    >
      {/* <ModalHeader toggle={showCloseIcon ? canClose : undefined}>
               
            </ModalHeader> */}
      <ModalBody className="p-6 pt-2">
        <h5 className="modal-title mb-2"> {title || getTitle()}</h5>
        <p className="modal-message mb-0">{bodyContent || getBodyContent()}</p>
      </ModalBody>
      {footerContent && (
        <div className="custom-footer">
          {footerContent}
          {!disableClose && showCloseIcon && (
            <button className="modal-btn cancel-btn" onClick={toggle}>
              Cancel
            </button>
          )}
        </div>
      )}
    </Modal>
  );
};

ChatDisableModalComponent.displayName = "ChatDisableModal";

const ChatDisableModal = memo(ChatDisableModalComponent);

ChatDisableModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  bodyContent: PropTypes.string,
  footerContent: PropTypes.node,
  disableClose: PropTypes.bool,
  userDetails: PropTypes.shape({
    primary: PropTypes.object,
    secondary: PropTypes.object,
  }),
};

export default ChatDisableModal;
